/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSkillsVersionContent } from "../../funcs/llmSkillsVersionContent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetSkillVersionContentRequest$inboundSchema,
};

export const tool$llmSkillsVersionContent: ToolDefinition<typeof args> = {
  name: "llm-skills-version-content",
  description: `Download skill version content

Download the zip bundle for a specific skill version.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSkillsVersionContent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
